module.exports = __webpack_public_path__ + "assets/img/preview.d8d16ab069c1ffd3fd1cd5bf5e3d01d3.jpg";